export function getBrand(brand) {
  const brands = {
    Evvi: {
      name: "Evvi Aftercare",
      src: "/evvi-logo.png",
      alt: "Evvi Aftercare",
      className: "evvi-logo",
      url: "https://evviaftercare.com/",
      supportEmail: "support@evviaftercare.com",
      phoneNumber: "206-432-4611",
    },
    "Resting Waters": {
      name: "Resting Waters",
      src: "/resting-waters-logo.png",
      alt: "Resting Waters",
      className: "resting-waters-logo",
      url: "https://restingwaters.com/",
      supportEmail: "support@restingwaters.com",
      phoneNumber: "206-708-0621",
    },
  };

  return (
    brands[brand] || {
      name: "Evvi Aftercare & Resting Waters",
      src: "/evvi-resting-waters-logo.png",
      alt: "Evvi Aftercare & Resting Waters",
      className: "evvi-resting-waters-logo",
      url: "https://evviaftercare.com/",
      supportEmail: "support@evviaftercare.com",
      phoneNumber: "206-432-4611",
    }
  );
}
